var exports = {
  "D": "Heading__Qcyb8f",
};

module.exports = exports;
